import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AdvisingCategory } from '../../models/advising/advising-category.interface';
import { AvailableCoachingSlot } from '../../models/advising/available-coaching-slot.interface';
import { AdvisingAppointment } from '../../models/advising/advising-appointment.interface';
import { HttpUtilityService } from '../../utility/http-utility/http-utility.service';
import { AdvisingAvailableDates, AdvisingSession } from '@edassist/api';

@Injectable({ providedIn: 'root' })
export class AdvisingService {
	private readonly RELATIVE_URL = 'advising/';
	private readonly PARTICIPANTS_RELATIVE_URL = 'participants/';

	constructor(private readonly http: HttpClient) {}

	getAdvisingCategories(
		participantId: number,
		activeProductId: number
	): Observable<Array<AdvisingCategory>> {
		let queryParams = new HttpParams();
		queryParams = queryParams.append(
			'productTypeId',
			activeProductId.toString()
		);

		return this.http.get<Array<AdvisingCategory>>(
			`${this.PARTICIPANTS_RELATIVE_URL}${participantId}/${this.RELATIVE_URL}categories`,
			{ params: queryParams }
		);
	}

	getAvailableSlots(
		participantId: number,
		selectedDate: Date,
		category: number,
		activeProductId: number
	): Observable<Array<AvailableCoachingSlot>> {
		let params = new HttpParams();
		params = params.append('selectedDate', selectedDate.toISOString());
		params = params.append(
			'offSet',
			((selectedDate.getTimezoneOffset() / 60) * -1).toString()
		);
		params = params.append('productTypeId', activeProductId.toString());
		params = params.append('category', category.toString());

		return this.http.get<Array<AvailableCoachingSlot>>(
			`${this.PARTICIPANTS_RELATIVE_URL}${participantId}/${this.RELATIVE_URL}available-slots`,
			{ params }
		);
	}

	getAvailableDates(
		participantId: number,
		selectedDate: Date,
		category: number,
		activeProductId: number
	): Observable<Array<AdvisingAvailableDates>> {
		let params = new HttpParams();
		params = params.append('selectedDate', selectedDate.toISOString());
		params = params.append('numberOfDays', '60');
		params = params.append('productTypeId', activeProductId.toString());
		params = params.append('advisingCategory', category.toString());

		return this.http.get<Array<AdvisingAvailableDates>>(
			`${this.PARTICIPANTS_RELATIVE_URL}${participantId}/${this.RELATIVE_URL}available-dates`,
			{ params }
		);
	}

	createAdvisingAppointment(
		participantId: number,
		advisingAppointment: AdvisingAppointment
	): Observable<AdvisingAppointment> {
		return this.http.post<AdvisingAppointment>(
			`${this.PARTICIPANTS_RELATIVE_URL}${participantId}/${this.RELATIVE_URL}advising-appointment`,
			advisingAppointment
		);
	}

	updateAdvisingAppointment(
		participantId: number,
		productTypeId: number,
		advisingAppointment: AdvisingAppointment
	): Observable<AdvisingAppointment> {
		return this.http.put<AdvisingAppointment>(
			`${this.PARTICIPANTS_RELATIVE_URL}${participantId}/advising/advising-appointment/${advisingAppointment.id}
		?productTypeId=${productTypeId}`,
			advisingAppointment
		);
	}

	getParticipantAppointments(
		participantId: number,
		productTypeId: number
	): Observable<Array<AdvisingSession>> {
		return this.http.get<Array<AdvisingSession>>(
			`${this.PARTICIPANTS_RELATIVE_URL}${participantId}/advising/advising-appointments?productTypeId=${productTypeId}`
		);
	}
	deleteAppointment(
		participantId: number,
		appointmentId: string,
		productTypeId: number
	): Observable<void> {
		return this.http.delete<void>(
			`${this.PARTICIPANTS_RELATIVE_URL}${participantId}/advising/advising-appointment/${appointmentId}?productTypeId=${productTypeId}`
		);
	}
}
